import React from 'react';
import { motion } from 'framer-motion';
import '../../assets/styles/PackagesSection.css';

const packages = [
  {
    name:     'Starter',
    featured: false,
    price:    '$997',
    timeline: '2 weeks',
    intro:    'A clean 4-page site for businesses that need to look professional fast.',
    features: [
      'Home, About, Services, Contact',
      'Template-based build with custom styling',
      'Mobile responsive',
      'Contact form and Google Analytics',
      'Basic on-page SEO',
      '30 days post-launch support',
    ],
  },
  {
    name:     'Growth',
    featured: true,
    price:    '$1,997',
    timeline: '3-4 weeks',
    intro:    'The main offer: a custom lead-focused website for small local businesses.',
    features: [
      'Custom design up to 7 pages',
      'Messaging and page structure guidance',
      'Local SEO foundation',
      'Domain and hosting setup',
      'Analytics and Search Console',
      '60 days post-launch support',
    ],
  },
  {
    name:     'Authority',
    featured: false,
    price:    '$3,500',
    timeline: '3-5 weeks',
    intro:    'For businesses that need custom logic, booking flows, calculators, portals, or workflows.',
    features: [
      'Custom website up to 12 pages',
      'Process audit and scope lock',
      'Scoped custom functionality',
      'Lead funnel or CMS setup',
      'Testing and performance pass',
      '90 days post-launch support',
    ],
  },
];

const PackagesSection = () => (
  <motion.section
    className="packages-section section"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: 'easeOut' }}
    viewport={{ once: true, amount: 0.1 }}
  >
    <div className="section-inner">
      <p className="eyebrow centered">Pricing</p>
      <h2 className="centered">Packages</h2>

      <div className="packages-container">
        {packages.map((pkg, i) => (
          <motion.div
            key={pkg.name}
            className={`package-card${pkg.featured ? ' featured' : ''}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 + i * 0.15 }}
            viewport={{ once: true, amount: 0.1 }}
          >
            {pkg.featured && <span className="featured-badge">Most popular</span>}
            <h3>{pkg.name}</h3>
            <p className="body-lora">{pkg.intro}</p>

            <div className="package-meta">
              <div>
                <span>Starting at</span>
                <b>{pkg.price}</b>
              </div>
              <div>
                <span>Timeline</span>
                <b>{pkg.timeline}</b>
              </div>
            </div>

            <ul>
              {pkg.features.map(f => <li key={f}>{f}</li>)}
            </ul>

            <a
              href={`/packages#${pkg.name.toLowerCase()}`}
              className={pkg.featured ? 'btn-accent' : 'btn-primary-warm'}
            >
              Learn more
            </a>
          </motion.div>
        ))}
      </div>
    </div>
  </motion.section>
);

export default PackagesSection;
